import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Brand } from './brand';
import { environment } from '../environments/environment';
 
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
 
@Injectable({
  providedIn: 'root'
})
export class BrandService {
	baseUrl = environment.baseUrl;
  private brandsUrl = this.baseUrl +'/api/brands';  // URL to web api
  constructor( 
    private http: HttpClient
  ) { }
 
  getBrands (): Observable<Brand[]> {
    return this.http.get<Brand[]>(this.brandsUrl)
  }

  
  getBrand(brandid: number): Observable<Brand> {
    const url = `${this.brandsUrl}/${brandid}`;
    return this.http.get<Brand>(url);
  }
 
  addBrand (brand: Brand): Observable<Brand> {
    return this.http.post<Brand>(this.brandsUrl, brand, httpOptions);
  }
 
  deleteBrand (brand: Brand | number): Observable<Brand> {
    const id = typeof brand === 'number' ? brand : brand.brandid;
    const url = `${this.brandsUrl}/${id}`;
 
    return this.http.delete<Brand>(url, httpOptions);
  }
 
  updateBrand (brand: Brand): Observable<any> {
    return this.http.put(this.brandsUrl, brand, httpOptions);
  }
}